import DOMPurify from 'dompurify';

/**
 * Every string passed to dangerouslySetInnerHTML (or innerHTML for PDFs) goes through this first.
 * Contract, NDA and template HTML has client-entered values substituted in (company name,
 * address, ...), so without it a client could plant script that runs when staff open the
 * document in the CRM. Strips scripts, event-handler attributes and javascript: URLs; keeps
 * formatting, <style> blocks (FORCE_BODY keeps a leading one), links and data: images.
 */
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(String(html ?? ''), { ADD_ATTR: ['target'], FORCE_BODY: true });
}
